module.exports = __webpack_public_path__ + "images/loading---dd6b7b0bf5c3af22499abc0a9ee1e1b2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/vendor/style/img/loading.gif
// module id = 399
// module chunks = 0